import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './CenteredContent.css'; 

function CenteredContent({ children }) {

    const containerStyle = {
        paddingTop: '40px', // Adjust the value as needed
    };
    return (
        <Container style={containerStyle} className="CenteredContent">
            <Row className="justify-content-center">
            <Col xs={12} md={8} lg={7}>
                {children}
            </Col>
            </Row>
        </Container>
    );
}

export default CenteredContent;